import { Link } from "react-router-dom";
import { CornerDownRight } from "lucide-react";
import type { GroupMember } from "../types";
import { TagPill } from "./Pills";
import { memberDisplayName } from "../utils/format";

interface MemberTreeNameProps {
  member: GroupMember;
  to?: string;
  isDependent: boolean;
  children?: never;
}

/** Name cell with the subscriber tree connector and synthetic member badges. */
export function MemberTreeName({ member, to, isDependent }: MemberTreeNameProps) {
  const name = memberDisplayName(member);

  return (
    <span className="inline-flex items-center gap-1.5">
      {isDependent && <CornerDownRight size={13} className="shrink-0 text-gray-400" aria-hidden="true" />}
      {to ? (
        <Link to={to} className="whitespace-nowrap font-medium text-brand-navy underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-brand-green-50 rounded">
          {name}
        </Link>
      ) : (
        <span className="whitespace-nowrap font-medium text-brand-navy">{name}</span>
      )}
      {member.memberType === "SpockCohort" && <TagPill label={`${member.cohortYear ?? ""} ${member.cohortGender ?? ""}`.trim()} tone="navy" />}
      {member.memberType === "GradientDoe" && <TagPill label="Gradient" tone="green" />}
    </span>
  );
}
